import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e49f346c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableRow.scss?vue&type=style&index=0&id=e49f346c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49f346c",
  null
  
)

export default component.exports